import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "services" }
const _hoisted_2 = { class: "services__container container" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "services__title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    class: "services__title--logo",
    src: "assets/img/exalab-logo-blanco.svg",
    alt: ""
  }),
  /*#__PURE__*/_createElementVNode("p", { class: "services__title--p" }, "Somos un sistema especialiado en atención"),
  /*#__PURE__*/_createElementVNode("h2", { class: "services__title--h2" }, "Preocupacional y Ocupacional")
], -1)
const _hoisted_4 = { class: "services__image" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "services__info" }
const _hoisted_7 = { class: "services__info--h3" }
const _hoisted_8 = { class: "services__info--p" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "services__button--span" }, "Ver más", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("i", { class: "services__button--i ri-arrow-right-up-line" }, null, -1)

import Modulos from '@/entities/Modulos';
import ModulosService from '@/services/ModulosService';
import { onMounted, Ref, ref } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ServicesSection',
  setup(__props) {

const modulosService: Ref<ModulosService> = ref(new ModulosService())
const modulos: Ref<Modulos[]> = ref([])

onMounted(async () => {
  getModulos()
})

const getModulos = async () => {
  modulos.value = await modulosService.value.getModulos()
}


return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulos.value, (modulo, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: index,
          class: "services__box"
        }, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("img", {
              class: "services__image--img",
              src: 'assets/img/services/' + modulo.image,
              alt: ""
            }, null, 8, _hoisted_5)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("h3", _hoisted_7, [
              _createElementVNode("i", {
                class: _normalizeClass(modulo.icon)
              }, null, 2),
              _createElementVNode("span", null, _toDisplayString(modulo.name), 1)
            ]),
            _createElementVNode("p", _hoisted_8, _toDisplayString(modulo.short_descript), 1),
            _createVNode(_component_RouterLink, {
              to: { name: 'services', params: { id: modulo.id } },
              class: "services__info--a services__button"
            }, {
              default: _withCtx(() => [
                _hoisted_9,
                _hoisted_10
              ]),
              _: 2
            }, 1032, ["to"])
          ])
        ]))
      }), 128))
    ])
  ]))
}
}

})